var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('BlackoutPeriodForm',{attrs:{"urlIds":_vm.urlIds,"startDate":_vm.startDate,"endDate":_vm.endDate,"disable-repeating":true},on:{"submit":function($event){return _vm.onSubmit($event)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }